import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchProductReview } from "../../services/productReview";

const initialState = {
  reviewsAndRatings: [],
  loading: false,
  error: null,
};

export const fetchReview = createAsyncThunk(
  "ratings/fetchReview",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchProductReview(id);
      // The API returns { success: true, reviews: [...], count: number }
      return response.reviews || [];
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch reviews",
      );
    }
  },
);

const reviewSlice = createSlice({
  name: "ratings",
  initialState,
  reducers: {
    clearReviews: (state) => {
      state.reviewsAndRatings = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReview.fulfilled, (state, action) => {
        state.reviewsAndRatings = action.payload;
        state.loading = false;
        state.error = null; // Clear any previous errors
      })
      .addCase(fetchReview.rejected, (state, action) => {
        console.error(
          "Failed to fetch reviews:",
          action.payload || action.error.message,
        );
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.reviewsAndRatings = []; // Clear reviews on error
      });
  },
});

export const { clearReviews } = reviewSlice.actions;
export default reviewSlice.reducer;
